import { cva } from 'class-variance-authority';
export const bannerVariants = cva('flex items-center gap-3 rounded-md border px-3 py-2 text-sm font-medium', {
    variants: {
        variant: {
            default: 'bg-secondary text-secondary-foreground border-input',
            info: 'bg-blue-100 text-sky-700 border-blue-300',
            success: 'bg-emerald-100 text-emerald-700 border-emerald-300',
            warning: 'bg-orange-100 text-orange-700 border-orange-300',
            error: 'bg-red-100 text-red-700 border-red-300',
            transparent: 'bg-transparent text-foreground border-input',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
